import { inject, Injectable } from '@angular/core';
import { ApplicationStore } from '@core/store/application.store';
import { Menu } from './menu.interface';

@Injectable()
export class MenuService {
  private readonly applicationStore = inject(ApplicationStore);

  toggleMenu(): void {
    this.applicationStore.toggleMenu();
  }

  closeMenu(): void {
    this.applicationStore.closeMenu();
  }

  getMainMenu(): Menu[] {
    return [
      {
        menuIcon: 'menu-home',
        menuTitle: 'menu.dashboard',
        path: '/dashboard',
      },
      {
        menuIcon: 'menu-contracts',
        menuTitle: 'menu.contracts',
        path: '/contracts',
      },
      {
        menuIcon: 'menu-invoices',
        menuTitle: 'menu.invoices',
        path: '/invoices',
      },
      {
        menuIcon: 'menu-contact',
        menuTitle: 'menu.contact',
        path: '/contact',
      },
    ];
  }

  getUserMenu(): Menu[] {
    return [
      {
        menuIcon: 'menu-settings',
        menuTitle: 'menu.settings',
        path: '/settings',
      },
      {
        menuIcon: 'menu-contact',
        menuTitle: 'menu.contact',
        path: '/contact',
      },
    ];
  }
}
